// extracted by mini-css-extract-plugin
export default {"home":"wVmdr84N6BM96Q6RFb5l2Q=="};